export default __webpack_public_path__ + "static/char-29-a7dbdf4def010a9efc7cd71cd5488d16.gif";